import { useEffect, useState } from 'react';

export const SEASONS = [
  { name: 'spring', a: '#ff85b0', b: '#e84e88', c: '#ffb4cd', icon: '#ff85b0', stroke: '#c44a78' },
  { name: 'summer', a: '#7dc878', b: '#3f9447', c: '#b8e2af', icon: '#7dc878', stroke: '#3f9447' },
  { name: 'autumn', a: '#ee9342', b: '#b13e1a', c: '#f4ba60', icon: '#ee9342', stroke: '#a8451f' },
  { name: 'winter', a: '#ffffff', b: '#a8c2d0', c: '#dceaf2', icon: '#dceaf2', stroke: '#7d96a4' },
];

const SEASON_DURATION_MS = 15000;
const EVENT = 'blossomSeasonChanged';

let _idx = Math.floor(Math.random() * SEASONS.length);
let _interval = null;
let _refCount = 0;

const ensureInterval = () => {
  if (_interval) return;
  _interval = setInterval(() => {
    _idx = (_idx + 1) % SEASONS.length;
    window.dispatchEvent(new CustomEvent(EVENT, { detail: _idx }));
  }, SEASON_DURATION_MS);
};

const teardownInterval = () => {
  if (_refCount === 0 && _interval) {
    clearInterval(_interval);
    _interval = null;
  }
};

export const getSeasonIndex = () => _idx;

export function useBlossomSeason() {
  const [idx, setIdx] = useState(_idx);

  useEffect(() => {
    _refCount++;
    ensureInterval();
    const onChange = (e) => setIdx(e.detail);
    window.addEventListener(EVENT, onChange);
    return () => {
      window.removeEventListener(EVENT, onChange);
      _refCount--;
      teardownInterval();
    };
  }, []);

  return [idx, SEASONS[idx]];
}
